import React from "react";
import { Chart } from "chart.js/auto"
import { CategoryScale } from "chart.js";
import { Line } from "react-chartjs-2";
import { displayMessage } from "../../services/helper";

Chart.register(CategoryScale);

export default function EvoExerciseChart({ evoExerciseChart }) {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                max: 3.5,
                min: 0,
                ticks: {
                    stepSize: 0.5
                }
            }
        },
        type: 'line',
        plugins: {
            tooltip: {
                callbacks: {
                    footer: (context) => {
                        const tooltip = evoExerciseChart.labels.find(value => value.formattedDate === context[0].label)
                        return [
                            displayMessage('AVG_MONITORY_STARS', [tooltip?.avg_monitory_stars]),
                            displayMessage('AVG_EXERCISE_STARS', [tooltip?.avg_exercise_stars]),
                            displayMessage('PERCENT_PRESENCES', [tooltip?.present_percent]),
                        ]
                    },
                }
            }
        }
    };

    const data = {
        labels: evoExerciseChart?.date[0],
        datasets: [{
            label: displayMessage('STARS_EXERCISE_AVARGE'),
            data: evoExerciseChart?.avg_exercise_stars[0]
        }]
    };

    return (
        <>
            {data && (
                <Line
                    data={data}
                    width={300}
                    height={300}
                    options={options}
                    style={{ maxHeight: 300 }}
                />
            )}
        </>
    )
}